<template>
    <section>
        <div class="t-headline5 mt3">
            {{$t('1598')}}
            <!-- 약관동의 -->
        </div>
        <div class="t-body3 mt6 t-color-content1">
            {{$t('1599')}}
            <!-- 계속하면 아래 약관에 동의하는 것입니다. -->
        </div>

        <div class="mt30">
            <div class="mdc-card">
                <div class="policy-body">
                    <div class="title">
                        <div>
                            <router-link :to="{name: 'JoinTerms'}">
                                <span class="t-subtitle3">
                                    {{$t('1600')}}
                                    <!-- 서비스 이용약관 -->
                                </span>
                            </router-link>

                        </div>
                        <div class="check">
                            <div class="mdc-form-field mdc-form-field--align-end">
                                <div class="mdc-checkbox ">
                                    <input type="checkbox"
                                        class="mdc-checkbox__native-control"
                                        v-model="checkTerms"
                                    />
                                    <div class="mdc-checkbox__background check-red">
                                        <svg class="mdc-checkbox__checkmark"
                                            viewBox="0 0 24 24">
                                            <path class="mdc-checkbox__checkmark-path"
                                                fill="none"
                                                d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                                        </svg>
                                        <div class="mdc-checkbox__mixedmark"></div>

                                    </div>
                                </div>
                                <label for="basic-checkbox t-button"></label>

                            </div>
                        </div>
                    </div>

                    <div class="mt26 t-body3 contents" v-html="htmlTermsOfService">
                    </div>
                </div>
            </div>
        </div>

        <div class="mt8 mb20">
            <div class="mdc-card">
                <div class="policy-body">
                    <div class="title">
                        <div>
                            <router-link :to="{name: 'JoinPrivacy'}">
                                <span class="t-subtitle3">
                                    {{$t('1601')}}
                                    <!-- 개인정보 보호정책 -->
                                </span>
                            </router-link>

                        </div>
                        <div class="check">
                            <div class="mdc-form-field mdc-form-field--align-end">
                                <div class="mdc-checkbox ">
                                    <input type="checkbox"
                                        class="mdc-checkbox__native-control"
                                        v-model="checkPrivacy"
                                    />
                                    <div class="mdc-checkbox__background check-red">
                                        <svg class="mdc-checkbox__checkmark"
                                            viewBox="0 0 24 24">
                                            <path class="mdc-checkbox__checkmark-path"
                                                fill="none"
                                                d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                                        </svg>
                                        <div class="mdc-checkbox__mixedmark"></div>

                                    </div>
                                </div>
                                <label for="basic-checkbox t-button"></label>

                            </div>
                        </div>
                    </div>

                    <div class="mt26 t-body3 contents" v-html="htmlPrivacypolicy">

                    </div>
                </div>
            </div>
        </div>
        <hr class="divider">
        <div class="mt20">
            <div class="mdc-card">
                <div class="policy-body">
                    <div class="title">
                        <div>
                            <span class="t-subtitle3">
                                {{$t('1602')}}
                                <!-- 전체 동의 -->
                            </span>
                        </div>
                        <div class="check">
                            <div class="mdc-form-field mdc-form-field--align-end">
                                <div class="mdc-checkbox ">
                                    <input type="checkbox"
                                        class="mdc-checkbox__native-control"
                                        v-model="checkAll"
                                        @change="handleCheckAll"
                                        :checked="validAgree"
                                    />
                                    <div class="mdc-checkbox__background check-red">
                                        <svg class="mdc-checkbox__checkmark"
                                            viewBox="0 0 24 24">
                                            <path class="mdc-checkbox__checkmark-path"
                                                fill="none"
                                                d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                                        </svg>
                                        <div class="mdc-checkbox__mixedmark"></div>

                                    </div>
                                </div>
                                <label for="basic-checkbox t-button"></label>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt50">
            <button class="mdc-button mdc-button--raised btn-red mr8" @click="next()">
                {{$t('1603')}}
            <!-- 다음 -->
            </button>
            <button class="mdc-button btn-white" @click="cancelJoin()" type="button">
                {{$t('1604')}}
                <!-- 취소 -->
            </button>
        </div>
        <router-view></router-view>
    </section>
</template>

<script>
/**
 * 비밀번호 찾기 Step1 컴포넌트
 *
 * @author minkyoung.park@emcast.com
 * @author
 * @since 2019.04
 */

// MDC Components 선언 S
import {MDCSelect} from '@material/select';
import {MDCFormField} from '@material/form-field'
import {MDCRadio} from '@material/radio'
import {MDCRipple} from '@material/ripple'

// API 임포트
import joinApi from '@/api/joinApi.js'
// Store 임포트
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'

export default {
    data() {
        return {
            checkTerms: false,
            checkPrivacy: false,
            checkAll: false,
            htmlPrivacypolicy: null,
            htmlTermsOfService: null,

        }
    },

    mixins: [joinMixin],

    created() {
        if (!this.join.role || !this.join.responsibility) {
            this.$router.go(-1)
        }

    },

    mounted() {
        joinApi.terms().then((response) => {
            const termsUrl = response.data.data.TERMS_OF_SERVICE;
            const privacyUrl = response.data.data.PRIVACY_STATEMENT;

            joinApi.policyContents(termsUrl,'text').then((response) => {
                this.htmlTermsOfService = response.data
            })

            joinApi.policyContents(privacyUrl,'text').then((response) => {
                this.htmlPrivacypolicy = response.data
            })

        }).catch((err) => {
        })
    },


    computed: {
        ...mapState('join',{
            join : state => state,
        }),

        validAgree() {
            this.checkAll = this.checkTerms && this.checkPrivacy
            return this.checkAll
        }

    },


    methods: {
        ...mapMutations('join', ['SET_TERMS']),

        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        handleCheckAll() {
            if (this.checkAll) {
                this.checkTerms = true
                this.checkPrivacy = true
            }else {
                this.checkTerms = false
                this.checkPrivacy = false
            }
        },

        // 인증수단 조회 API 호출
        next() {
            if (this.checkAll) {
                let agreeDate = Date.now()
                this.SET_TERMS(agreeDate)

                if (this.join.socialLink.type === 'google' || this.join.socialLink.type === 'facebook' || this.join.socialLink.type === 'firebase') {
                    this.$router.push({
                        name: 'JoinSocialInput',
                    })
                }else {
                    this.$router.push({
                        name: 'JoinName'
                    })
                }
            }else {
                this.$snackOpen({
                    contents:this.$t('946'), //모든 약관에 동의해 주세요.
                    btnDisplay: ''
                }).then(() => {})
            }
        },



    }
}
</script>

<style>


</style>
